var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { Messages } from "../../../configuration/event-messages.constants";
import { EventAggregator } from "aurelia-event-aggregator";
import { Guid } from "../../../utilities/guid";
import { bindable, ViewResources } from "aurelia-templating";
import { Container, transient } from "aurelia-dependency-injection";
import { autoinject } from "aurelia-dependency-injection";
import { TemplatingEngine } from "aurelia-templating";
import { DashboardClientService } from "../../../services/dashboard/dashboard-client.service";
import "jquery";
import "jqueryui";
import "jquery-ui-touch-punch";
import "gridstack/dist/gridstack.all";
import { WindowCloseNotifierHelper } from "../../../utilities/window-close-notification-helper";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { DialogServiceConstants } from "../../../constants/basics/dialog.constants";
import { NotificationClientService, NotificationType } from '../../../services/basics/notification-client.service';
import { CacheClient, CacheLocation } from '../../../services/basics/client-caching.service';
import { UserClientService } from "../../../services/authentication/user-client.service";
import { Claims } from "../../../constants/authentication/claims";
var DashboardView = /** @class */ (function () {
    function DashboardView(templatingEngine, notificationService, dialogClient, dashboardClientService, resources, i18n, eventAggregator, container, cacheClient, userClientService) {
        var _this = this;
        this.templatingEngine = templatingEngine;
        this.notificationService = notificationService;
        this.dialogClient = dialogClient;
        this.dashboardClientService = dashboardClientService;
        this.resources = resources;
        this.i18n = i18n;
        this.eventAggregator = eventAggregator;
        this.container = container;
        this.cacheClient = cacheClient;
        this.userClientService = userClientService;
        this._selectedDashboardIdKey = "selected_dashboard_id";
        this._shareDashboard = false;
        this.menu = {};
        this.gridstackOptions = {
            alwaysShowResizeHandle: false,
            animate: true,
            auto: true,
            cellHeight: 160,
            draggable: { handle: ".widget", scroll: true, appendTo: "body" },
            handle: ".widget",
            height: 160,
            float: false,
            itemClass: "grid-stack-item",
            minWidth: 320,
            placeholderClass: "grid-stack-placeholder",
            resizable: { autoHide: true, handles: "se" },
            staticGrid: false,
            verticalMargin: 10,
            width: this.getGridWidth()
        };
        this.isManageDashboards = false;
        this.loadingWidgets = true;
        this.isEditing = false;
        this.overrideReadonly = false;
        this.step = 1;
        this.widgetConfigBroker = {};
        this.loadDashboardFunc = this.loadDashboard.bind(this);
        this.removeItem = function (e) {
            _this.isRemovingDashboard = false;
            _this.itemToDelete = e.target;
            //DO NOT REMOVE BECAUSE IT IS NEEDED FOR WEBPACK
            if (!window["SystemJS"]) {
                require("" + "../admin/manage-organization/common/delete-modal");
            }
            _this.dialogClient.show(DialogServiceConstants.URLs.DeleteModal, _this);
        };
        this.editConfiguration = function (e) {
            if (_this.allWidgets) {
                _this.goToEditConfiguration(e);
            }
            else {
                _this.getWidgets().then(function (x) {
                    var e_1, _a;
                    var list = new Array();
                    try {
                        for (var _b = __values(x.widgets), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var widget = _c.value;
                            list.push(widget);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    _this.widgets = list;
                    _this.allWidgets = list;
                    _this.goToEditConfiguration(e);
                });
            }
        };
        this.openMenu = function (guid, e) {
            var e_2, _a;
            e.preventDefault();
            e.stopPropagation();
            var self;
            try {
                for (var _b = __values(Object.keys(_this.menu)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var x = _c.value;
                    if (_this.menu[guid] === _this.menu[x] && _this.menu[guid] === true) {
                        self = true;
                    }
                    _this.menu[x] = false;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            //If Self is already Open.. Don't re-open the dropdown
            if (!self) {
                _this.menu[guid] = true;
            }
        };
    }
    Object.defineProperty(DashboardView.prototype, "showDashboardPlaceholder", {
        get: function () {
            return (!this.currentDashboard
                || !this.currentDashboard.dashboardWidgets
                || this.currentDashboard.dashboardWidgets.length === 0)
                && !this.loadingWidgets;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DashboardView.prototype, "canEdit", {
        get: function () {
            var result = this.currentDashboard && (this.overrideReadonly || !this.currentDashboard.isReadonly);
            this._canEdit = result;
            return this._canEdit;
        },
        set: function (canEdit) {
            this._canEdit = canEdit;
        },
        enumerable: false,
        configurable: true
    });
    DashboardView.prototype.getGridWidth = function () {
        return 12;
    };
    DashboardView.prototype.searchTextChanged = function (newValue, oldValue) {
        var e_3, _a;
        var list = new Array();
        if (this.searchText) {
            try {
                for (var _b = __values(this.allWidgets), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (item.title.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                        list.push(item);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        else {
            list = this.allWidgets;
        }
        this.widgets = list;
    };
    DashboardView.prototype.selectWidget = function (model, modelFunc) {
        if (modelFunc === void 0) { modelFunc = null; }
        this.selectedWidget = model;
        this.widgetConfigBroker = {};
        this.widgetConfigBroker.widgetModel = modelFunc;
        this.widgetConfigBroker.parameter = this.getParameterForConfiguration(model);
        this.currentConfiguration = this.getConfigurationPath(model.internalName);
    };
    DashboardView.prototype.getParameterForConfiguration = function (model) {
        return this.getBasePath() + model.internalName;
    };
    DashboardView.prototype.getConfigurationPath = function (internalName) {
        //DO NOT REMOVE BECAUSE IT IS NEEDED FOR WEBPACK
        if (!window["SystemJS"]) {
            require("" + "../../../widgets/" + internalName + "-configuration");
        }
        return "../../../widgets/" + internalName + "-configuration";
    };
    DashboardView.prototype.detached = function () {
        this.userClientService.unsubscribeOnUserUpdate(this.loadDashboardFunc);
    };
    DashboardView.prototype.attached = function () {
        var _this = this;
        this.canEdit = this.userClientService.currentUser.allowedClaims.some(function (value) {
            return value.permission === Claims.EditDashboard;
        });
        this.loadingWidgets = true;
        window.GridStackUI.prototype.cellWidth = function () {
            return 160;
        };
        this.eventAggregator.subscribe(Messages.documentClick, function (x) {
            var e_4, _a;
            try {
                for (var _b = __values(Object.keys(_this.menu)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var y = _c.value;
                    _this.menu[y] = false;
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        });
        this.gridElement = $("#grid-stack");
        this.gridstackOptions.cellHeight = 160;
        var gridstack = this.gridElement.gridstack(this.gridstackOptions);
        this.grid = gridstack.data("gridstack");
        this.grid.disable();
        this.userClientService.subscribeOnUserUpdate(this.loadDashboardFunc);
        this.loadDashboard();
    };
    DashboardView.prototype.loadDashboard = function () {
        if (!this.isManageDashboards) {
            this.loadUserDashboards();
        }
        else {
            this.loadGlobalDashboards();
        }
    };
    DashboardView.prototype.reloadDashboard = function () {
        this.loadingWidgets = true;
        this.load(this.currentDashboard);
        this.isEditing = false;
    };
    DashboardView.prototype.loadGlobalDashboards = function () {
        var _this = this;
        this.dashboardClientService.getGlobalDashboards().then(function (x) {
            var dashboards = Enumerable.from(x.dashboards);
            var selectedDashboard = dashboards.first(function (d) { return d.dashboardId == _this.globalDashboardId; });
            _this.load(selectedDashboard);
        });
    };
    DashboardView.prototype.loadUserDashboards = function () {
        var _this = this;
        this.getDashboardsForUser().then(function (dashboardsResult) {
            if (dashboardsResult.dashboards) {
                _this.dashboards = dashboardsResult.dashboards;
            }
            if (_this.dashboards && _this.dashboards.length > 0) {
                _this.cacheClient.get(_this._selectedDashboardIdKey, CacheLocation.LocalStorage).then(function (dashboardid) {
                    var dashboardEnumerable = Enumerable.from(_this.dashboards);
                    var selectedDashboard = dashboardEnumerable.firstOrDefault(function (z) { return z.dashboardId == dashboardid; });
                    var index = _this.dashboards.indexOf(selectedDashboard);
                    _this.load(_this.dashboards[index]);
                }).catch(function (ex) {
                    _this.load(_this.dashboards[0]);
                });
            }
            else {
                _this.load({
                    id: 0,
                    createdDate: new Date(),
                    dashboardId: 0,
                    dashboardWidgets: [],
                    name: "Default",
                    atRoleLevel: false
                });
            }
        });
    };
    DashboardView.prototype.editDashboard = function () {
        if (this.canEdit) {
            this.serialize();
            this.grid.enable();
            this.isEditing = true;
            WindowCloseNotifierHelper.setMessage(this.i18n.tr("dashboard-not-saved"));
        }
    };
    DashboardView.prototype.toggleEditMode = function () {
        this.isEditing = !this.isEditing;
    };
    DashboardView.prototype.canDeactivate = function () {
        if (this.isEditing) {
            return confirm(this.i18n.tr("dashboard-not-saved"));
        }
        else {
            return true;
        }
    };
    DashboardView.prototype.doneEditing = function () {
        this.grid.disable();
        this.isEditing = false;
        this.save();
        WindowCloseNotifierHelper.setMessage(null);
    };
    DashboardView.prototype.cancelEditingInner = function (shouldLoad) {
        if (shouldLoad === void 0) { shouldLoad = true; }
        if (shouldLoad)
            this.load(this.currentDashboard);
        this.grid.disable();
        this.isEditing = false;
        // this.save();
        WindowCloseNotifierHelper.setMessage(null);
    };
    DashboardView.prototype.cancelEditing = function (load) {
        var _this = this;
        if (load === void 0) { load = true; }
        if (this.allWidgets) {
            this.cancelEditingInner(load);
        }
        else {
            this.getWidgets().then(function (x) {
                var e_5, _a;
                var list = new Array();
                try {
                    for (var _b = __values(x.widgets), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var widget = _c.value;
                        list.push(widget);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                _this.widgets = list;
                _this.allWidgets = list;
                _this.cancelEditingInner(load);
            });
        }
        this.searchText = null;
    };
    DashboardView.prototype.configure = function () {
        if (this.selectedWidget.hasConfiguration) {
            this.step++;
        }
        else {
            this.saveWidget();
        }
    };
    DashboardView.prototype.addWidget = function () {
        var _this = this;
        if (this.allWidgets) {
            this.goToAddStep();
        }
        else {
            this.getWidgets().then(function (x) {
                var e_6, _a;
                var list = new Array();
                try {
                    for (var _b = __values(x.widgets), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var widget = _c.value;
                        list.push(widget);
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
                _this.widgets = list;
                _this.allWidgets = list;
                _this.goToAddStep();
            });
        }
    };
    DashboardView.prototype.goToAddStep = function () {
        this.isEditConfiguration = false;
        this.step = 1;
        this.addNewVisible = true;
    };
    DashboardView.prototype.hideAdd = function () {
        this.selectedWidget = null;
        this.addNewVisible = false;
        this.step = 1;
        this.searchText = null;
    };
    DashboardView.prototype.saveWidgetConfiguration = function () {
        var node = this.editingElementConfiguration.data("_gridstack_node");
        var dashboardWidgetId = this.editingElementConfiguration.data("dashboardWidgetId");
        this.grid.removeWidget(this.editingElementConfiguration.get(0));
        var config = this.widgetConfigBroker.getModel();
        this.createWidget(dashboardWidgetId, this.selectedWidget, this.stringify(config), node.x, node.y, node.width, node.height, true);
        this.grid.disable();
        this.isEditing = false;
        this.save();
    };
    DashboardView.prototype.createWidget = function (dashboardWidgetId, widget, config, x, y, w, h, enhance, internalName) {
        if (internalName === void 0) { internalName = null; }
        var parsedConfig = this.parse(config);
        parsedConfig.height = h;
        parsedConfig.width = w;
        var element = this.grid.addWidget(this.getContainer(internalName ? internalName : widget.internalName, false, parsedConfig, widget), x, y, w, h, false);
        element.data({
            dashboardWidgetId: dashboardWidgetId,
            settings: config,
            internalName: internalName ? internalName : widget.internalName,
            widgetId: widget.widgetId
        });
        if (enhance) {
            var bindingContext = {
                config: parsedConfig,
                removeItem: this.removeItem,
                openMenu: this.openMenu,
                menu: this.menu,
                editConfiguration: this.editConfiguration
            };
            this.templatingEngine.enhance({ element: element.get(0), bindingContext: bindingContext, resources: this.resources });
            this.onEnhanced(element, this.parse(config));
        }
        this.hideAdd();
    };
    DashboardView.prototype.onEnhanced = function (element, model) { return; };
    DashboardView.prototype.delete = function () {
        if (this.isRemovingDashboard) {
            this.deleteDashboard();
        }
        else {
            this.dialogClient.hide();
            this.grid.removeWidget($(this.itemToDelete).closest(".grid-stack-item").get(0));
            this.save();
        }
    };
    DashboardView.prototype.goToEditConfiguration = function (e) {
        var e_7, _a;
        var _this = this;
        var element = $($(e.target).closest(".grid-stack-item").get(0));
        var config = element.data("settings");
        var viewmodel = element.data("internalName");
        try {
            for (var _b = __values(this.allWidgets), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (item.internalName === viewmodel) {
                    this.selectedWidget = item;
                    break;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        this.selectWidget(this.selectedWidget, function () { return _this.parse(config); });
        this.isEditConfiguration = true;
        this.editingElementConfiguration = element;
        this.step = 2;
        this.addNewVisible = true;
    };
    DashboardView.prototype.saveWidget = function () {
        var _this = this;
        var config = this.selectedWidget.hasConfiguration ? this.widgetConfigBroker.getModel() : {};
        this.createWidget(0, this.selectedWidget, this.stringify(config), 0, 0, 3, 2, true);
        setTimeout(function () {
            _this.save();
        });
    };
    DashboardView.prototype.save = function () {
        var e_8, _a;
        var _this = this;
        var widgets = $(".widget-host").toArray();
        try {
            for (var widgets_1 = __values(widgets), widgets_1_1 = widgets_1.next(); !widgets_1_1.done; widgets_1_1 = widgets_1.next()) {
                var widget = widgets_1_1.value;
                var viewModel = widget.au.controller.viewModel.viewModel;
                var vm = widget.au.controller.viewModel.currentViewModel;
                if (this.shouldSaveConfig(viewModel) && vm) {
                    var config = this.stringify(vm.model);
                    var element = $($(widget).closest(".grid-stack-item").get(0));
                    element.data({
                        settings: config
                    });
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (widgets_1_1 && !widgets_1_1.done && (_a = widgets_1.return)) _a.call(widgets_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
        this.serialize();
        this.currentDashboard.dashboardWidgets = this.serializedData;
        this.currentConfiguration = null;
        this.selectedWidget = null;
        this.persistDashboard(this.currentDashboard).then(function (x) {
            _this.currentDashboard = x.dashboard;
        });
    };
    DashboardView.prototype.shouldSaveConfig = function (viewModel) {
        return false;
    };
    DashboardView.prototype.removeDashboard = function () {
        this.isRemovingDashboard = true;
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModal, this);
    };
    DashboardView.prototype.deleteDashboard = function () {
        var _this = this;
        this.dashboardClientService.deleteUserDashboard(this.currentDashboard.dashboardId).then(function (x) {
            if (x.isSuccess) {
                _this.notificationService.show(_this.i18n.tr('successfully-deleted-text'), _this.i18n.tr('dashboard-has-been-successfully-deleted-text'), NotificationType.Success);
                _this.loadUserDashboards();
            }
            else {
                _this.notificationService.show(_this.i18n.tr('warning') + '!', _this.i18n.tr('dashboard-cannot-be-deleted-in-use-text'), NotificationType.Warning);
            }
            _this.dialogClient.hide();
            _this.isRemovingDashboard = false;
        }).catch(function (ex) {
            _this.dialogClient.hide();
            _this.isRemovingDashboard = false;
        });
    };
    DashboardView.prototype.shareDashboard = function () {
        require("./dialogs/share-dashboard-dialog");
        if (this.currentDashboard && this.canEdit && this._shareDashboard) {
            this.dialogClient.show(DialogServiceConstants.URLs.ShareDashboard, { dashboard: this.currentDashboard, vm: this });
        }
    };
    DashboardView.prototype.getContainer = function (viewModel, forNew, config, widget) {
        var html = "";
        html += "<div><div class=\"widget\"> ";
        var guid = Guid.generateGuid().replace(/-/g, "");
        var id = new Date().getTime() + Math.random();
        if (!forNew) {
            //Widget Menu
            html += "<div class=\"widget-menu row center-xs\" click.delegate=\"openMenu('" + guid + "', $event)\"><div class=\"widget-menu-dots\"></div></div>";
            //Menu Dropdown
            html += "<ul id=\"widget-menu-dropdown-" + id + "\" class=\"widget-menu-dropdown ${menu['" + guid + "'] ? 'visible':'' } animation-zoomin-top-right \">";
            if (widget.hasConfiguration && this.canEdit) {
                //Configure
                html += "<li class=\"menu-item configure row\" click.delegate=\"editConfiguration($event)\"><i class=\"menu-item-icon material-icons\">build</i><span class=\"menu-item-text\">Configure</span></li>";
            }
            if (this.canEdit) {
                //Remove
                html += "<li class=\"menu-item remove row\" click.delegate=\"removeItem($event)\"><i class=\"menu-item-icon material-icons\">clear</i><span class=\"menu-item-text\">Remove</span></li>";
            }
            //Closing Tags
            html += "</ul>";
        }
        var identifier = "widget-host-" + Guid.generateGuid();
        var vm = this.getBasePath() + viewModel;
        config.menuId = "widget-menu-dropdown-".concat(id);
        //DO NOT REMOVE BECAUSE IT IS NEEDED FOR WEBPACK
        if (!window["SystemJS"]) {
            require("" + "app/widgets/" + viewModel);
        }
        html += "<compose class=\"widget-host " + identifier + "\" view-model=\"" + vm + "\" model.bind=\"config\"></compose>";
        html += "</div></div>";
        return html;
    };
    DashboardView.prototype.getBasePath = function () {
        return "app/widgets/";
    };
    DashboardView.prototype.getModel = function (identifier, viewmodel, config) {
        return config;
    };
    DashboardView.prototype.load = function (dashboard) {
        var e_9, _a;
        this.currentDashboard = dashboard;
        this.grid.removeAll();
        var widgets = Enumerable.from(dashboard.dashboardWidgets).orderBy(function (x) { return x.y; }).toArray();
        var _loop_1 = function (node) {
            node.widget = node.widget ? node.widget : Enumerable.from(this_1.allWidgets).first(function (x) { return x.widgetId === node.widgetId; });
            var internalName = node.widget ? node.widget.internalName : Enumerable.from(this_1.allWidgets).first(function (x) { return x.widgetId === node.widgetId; }).internalName;
            this_1.createWidget(node.dashboardWidgetId, node.widget, node.settings, node.x, node.y, node.width, node.height, true, internalName);
        };
        var this_1 = this;
        try {
            for (var widgets_2 = __values(widgets), widgets_2_1 = widgets_2.next(); !widgets_2_1.done; widgets_2_1 = widgets_2.next()) {
                var node = widgets_2_1.value;
                _loop_1(node);
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (widgets_2_1 && !widgets_2_1.done && (_a = widgets_2.return)) _a.call(widgets_2);
            }
            finally { if (e_9) throw e_9.error; }
        }
        this.loadingWidgets = false;
        this.grid.disable();
    };
    DashboardView.prototype.persistDashboard = function (currentDashboard) {
        return this.dashboardClientService.persistDashboard(currentDashboard, this.isManageDashboards);
    };
    DashboardView.prototype.stringify = function (obj) {
        return JSON.stringify(obj);
    };
    DashboardView.prototype.parse = function (obj) {
        return JSON.parse(obj);
    };
    DashboardView.prototype.serialize = function () {
        var e_10, _a;
        var result = [];
        var elements = $("#grid-stack > .grid-stack-item").toArray();
        try {
            for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
                var el = elements_1_1.value;
                var jel = $(el);
                var node = jel.data("_gridstack_node");
                result.push({
                    id: jel.data("dashboardWidgetId"),
                    dashboardWidgetId: jel.data("dashboardWidgetId"),
                    dashboardId: this.currentDashboard.dashboardId,
                    widgetId: jel.data("widgetId"),
                    settings: jel.data("settings"),
                    x: node.x,
                    y: node.y,
                    width: node.width,
                    height: node.height
                });
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
            }
            finally { if (e_10) throw e_10.error; }
        }
        this.serializedData = result;
    };
    DashboardView.prototype.getWidgets = function () {
        return this.dashboardClientService.getWidgets();
    };
    DashboardView.prototype.getDashboardsForUser = function () {
        return this.dashboardClientService.getDashbardsForUser();
    };
    DashboardView.prototype.onDashboardSelected = function (dashboard) {
        if (dashboard) {
            this.cancelEditing(false);
            this.currentDashboard = dashboard;
            this.load(dashboard);
            this.cacheClient.put(this._selectedDashboardIdKey, dashboard.id);
        }
    };
    DashboardView.prototype.onAddNewDashboard = function () {
        require("./dialogs/add-new-dashboard-dialog");
        this.dialogClient.show(DialogServiceConstants.URLs.AddNewDashboard, this);
    };
    DashboardView.prototype.onEditDashboards = function () {
        require("./dialogs/edit-dashboards-metadata-dialog");
        this.dialogClient.show(DialogServiceConstants.URLs.EditDashboards, this);
    };
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DashboardView.prototype, "isManageDashboards", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DashboardView.prototype, "globalDashboardId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DashboardView.prototype, "addNewVisible", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DashboardView.prototype, "loadingWidgets", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DashboardView.prototype, "isEditing", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DashboardView.prototype, "overrideReadonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DashboardView.prototype, "selectedWidget", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DashboardView.prototype, "isEditConfiguration", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DashboardView.prototype, "searchText", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], DashboardView.prototype, "widgets", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DashboardView.prototype, "step", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], DashboardView.prototype, "currentConfiguration", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DashboardView.prototype, "widgetConfigBroker", void 0);
    DashboardView = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [TemplatingEngine, NotificationClientService,
            DialogClientService, DashboardClientService, ViewResources, I18N,
            EventAggregator, Container, CacheClient, UserClientService])
    ], DashboardView);
    return DashboardView;
}());
export { DashboardView };
